import React from 'react';
import './nav.css';

function Nav() {
    return (
        <nav className="nav">
            {/* <img src={logo} alt="codesquire"/> */}
            <ul className="nav-items">
                {/* <li class="brand"><strong>CodeSquire</strong></li> */}
                <li class="brand"><img src="https://res.cloudinary.com/rmkt/image/upload/v1589588651/code-squire/assets/Logo-03_snvgwt.png" alt="codesquire"/></li>
                <li>Motivation</li>
                <li>Approach</li>
                <li>Story</li>
                <li>Meet the Team</li>
                <li>Contact Us</li>
            </ul>
        </nav>
    );
}

export default Nav;